<template>
<transition name="modal">
<div id='weblink'>
	<div class="player-container">
      
		<div class="link-wrapper">

         <div class="header-container">
            <span class="header-title">{{asset.title}}</span>
         </div>

         <iframe id="weblink_frame" :src="asset.val"> 
         </iframe>

         <div class="buttons-wrapper">
            <img id="close_btn_weblink" class="close-btn-red" @click.stop="$emit('close')" src="./assets/img/bttn-close.svg">
         </div>

      </div>
	</div>
</div>
</transition>
</template>

<script>
import Overlay from './Overlay';

export default {
   extends: Overlay,

   data() {
      return {
      }
   },

}
</script>